var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "profile-icon",
    transform: "translate(-245 -753)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "blankbox",
    width: 16,
    height: 16,
    transform: "translate(245 753)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "profile-line",
    transform: "translate(248.059 754.577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4302",
    "data-name": "Path 4302",
    d: "M28.146,6.12a3.06,3.06,0,1,0-3.06-3.06,3.064,3.064,0,0,0,3.06,3.06m0-5.319A2.259,2.259,0,1,1,25.887,3.06,2.261,2.261,0,0,1,28.146.8",
    transform: "translate(-23.346)",
    fill: "#09c",
    stroke: "#09c",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4303",
    "data-name": "Path 4303",
    d: "M4.8,103.539a4.805,4.805,0,0,0-4.8,4.8.4.4,0,0,0,.8,0,4,4,0,1,1,8,0,.4.4,0,0,0,.8,0,4.8,4.8,0,0,0-4.8-4.8",
    transform: "translate(0 -96.359)",
    fill: "#09c",
    stroke: "#09c",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfIcon);
export default __webpack_public_path__ + "static/media/prof-icon.50276d9faf024e39b5783c6c7ef0bc0d.svg";
export { ForwardRef as ReactComponent };